import React, {Component} from 'react';
import {Button as ButtonReactstrap} from 'reactstrap';

class Button extends Component
{
    onClick = (e) => {
        if (this.props.action) {
            e.preventDefault()
            this.props.action(e)
            return false;
        }
    }

    render() {
        return (
            <ButtonReactstrap {...this.props}>
                {this.props.children}
            </ButtonReactstrap>
        );
    }
}

Button.defaultProps = {
    action: null
};

export default Button;
